import { render } from "./VueButton.vue?vue&type=template&id=6ffc17b7&scoped=true"
import script from "./VueButton.vue?vue&type=script&lang=js"
export * from "./VueButton.vue?vue&type=script&lang=js"

import "./VueButton.vue?vue&type=style&index=0&id=6ffc17b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffc17b7"]])

export default __exports__